import React from 'react'
import { Copy, Hero, SectionFull } from '@website2018/da-dobsonville'
import { Helmet } from "react-helmet-async";
import { decode } from 'he';
import PubRepsContainer from '../../containers/Data/PubRepsContainer'
import PeopleSlider from './PeopleSlider'
import { Ward } from '@website2018/sc-component'

class PeopleTemplate extends React.Component {
  state = {
    isOpen: false,
    person: null
  }

  render() {
    const { page, site } = this.props
    const p = page

    return [
      <Helmet
        defaultTitle={decode(p.seo.title !== '' ? p.seo.title : p.title.rendered)}
        meta={[
          {
            name: 'description',
            content: p.seo.metadesc !== '' ? p.seo.metadesc : p.excerpt.rendered
          },
          {
            name: 'og:title',
            content: p.seo['opengraph-title'] !== '' ? p.seo['opengraph-title'] : p.title.rendered
          },
          {
            name: 'og:description',
            content:
              p.seo['opengraph-description'] !== ''
                ? p.seo['opengraph-description']
                : p.excerpt.rendered
          },
          { name: 'og:url', content: `` },
          { name: 'og:site_name', content: `Democratic Alliance` },
          { name: 'og:type', content: `business` },
          { name: 'og:image', content: p.seo['opengraph-image'] || null },
          { name: 'fb:app_id', content: '1262049647255981' },
          { name: 'twitter:card', content: '”summary_large_image”' },
          { name: 'twitter:site', content: '@our_da' },
          {
            name: 'twitter:title',
            content: p.seo['twitter-title'] !== '' ? p.seo['twitter-title'] : p.title.rendered
          },
          {
            name: 'twitter:description',
            content:
              p.seo['twitter-description'] !== ''
                ? p.seo['twitter-description”']
                : p.excerpt.rendered
          },
          {
            name: 'twitter:image',
            content: p.seo['twitter-image'] !== '' ? p.seo['twitter-image'] : null
          }
        ]}
        htmlAttributes={{ lang: 'en' }}
      />,
      <Hero imageUrl={null} title={site.options.ourPeopleTitle} />,
      <SectionFull mt={'none'}>
        <div className={'col-md-8'}>
          <Copy intro html={site.options.ourPeopleDescription} />
        </div>
      </SectionFull>,
      <PubRepsContainer
        type={'portfolio'}
        query={{
          legislature: site.options.structureCode
        }}
        render={people => (
          <PeopleSlider
            highlight={site.province.highlight || null}
            people={people}
            title={
              site.province.acf.people_section_heading
                ? site.province.acf.people_section_heading
                : 'Meet the members of the provincial legislature'
            }
          />
        )}
      />,
      <Ward
        title={site.options.wardTitle}
        description={site.options.wardDescription}
        apiKey={process.env.RAZZLE_GOOGLE_MAPS_API_KEY}
      />
    ]
  }
}

// const typeBySlug = slug => {
//   switch (slug) {
//     case "national-assembly-members":
//       return "portfolio";
//     default:
//       return "province";
//   }
// };

export default PeopleTemplate
